import { useEffect } from 'react';
import clsx from 'clsx';
import { type FCC } from 'types';
import styles from './ValidationError.module.scss';

type ValidationErrorProps = React.HTMLAttributes<HTMLParagraphElement> & {
  message: string;
  setPreviousError?: (value: string) => void;
  className?: string;
};

const ValidationError: FCC<ValidationErrorProps> = (props) => {
  const { message, setPreviousError, className, ...paragraphProps } = props;

  useEffect(() => {
    if (message) {
      setPreviousError?.(message);
    }
  }, [message, setPreviousError]);

  return (
    <p
      className={clsx(styles.message, className)}
      role="status"
      aria-live="polite"
      {...paragraphProps}
    >
      {message}
    </p>
  );
};

export default ValidationError;
